import Link from "next/link";
import Heading from "../../components/Heading";
import React, { useState } from 'react'
import { useRouter } from "next/router";

const SettingsLayout = function ({ title = "", isLoading = false, children }) {
    const router = useRouter();
    const path = router.pathname
    console.log(path)
    return (
        <>
            <Heading title={title} showLoader={isLoading} />    

            <div className="container">
                <div className="row gutters-sm">
                    <div className="col-md-3 d-none d-md-block border-end">
                        <div className="card border-0">

                            <div className="list-group list-group-flush">

                                <Link href="/settings" className={`list-group-item list-group-item-action ${(path == '/settings') && 'active'}`}>
                                    General settings
                                </Link>
                                <Link href="/settings/website" className={`list-group-item list-group-item-action ${(path == '/settings/website') && 'active'}`}>
                                    Website settings
                                </Link>


                                <Link href="/settings/notification" className={`list-group-item list-group-item-action ${(path == '/settings/notification') && 'active'}`}>
                                    Notification settings
                                </Link>

                                <Link href="/settings/ecommerce" className={`list-group-item list-group-item-action ${(path == '/settings/ecommerce') && 'active'}`}>
                                    Ecommerce settings
                                </Link>
                                <Link href="/settings/mobileapp" className={`list-group-item list-group-item-action ${(path == '/settings/mobileapp') && 'active'}`}>
                                    Mobile app settings
                                </Link>


                            </div>
                        </div>
                    </div>
                    <div className="col-md-9">
                        <div className="card">
                            <div className="card-header border-bottom mb-3 d-flex d-md-none">
                                <ul className="nav nav-tabs card-header-tabs nav-gap-x-1" role="tablist">
                                    <li className="nav-item">
                                        <a href="/settings" data-toggle="tab" className="nav-link has-icon active"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/settings/ecommerce" data-toggle="tab" className="nav-link has-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-settings"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg></a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/settings/notification" data-toggle="tab" className="nav-link has-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-shield"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/settings/website" data-toggle="tab" className="nav-link has-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg></a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/settings/mobileapp" data-toggle="tab" className="nav-link has-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-credit-card"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg></a>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="tab-content">
                                {children}
                            </div>
                        </div>

                    </div>
                    
                </div>
            </div>
        </>
    );

}

export default SettingsLayout;